{
  "add": "Add",
  "age": {
    "range": {
      "ADULT": "Adult",
      "BABY": "Baby",
      "CHILD": "Child",
      "SENIOR": "Senior",
      "TURNING_SENIOR": "Turning Senior",
      "YOUNG_ADULT": "Young Adult",
      "YOUTH": "Youth"
    },
    "unknown": "Age unknown",
    "years": "Age {{ years }}"
  },
  "ages": {
    "ADULT": "(21-63) Adult",
    "BABY": "(0-1) Baby",
    "CHILD": "(1-5) Child",
    "SENIOR": "(65+) Senior",
    "TURNING_SENIOR": "(64) Turning Senior",
    "YOUNG_ADULT": "(19-20) Young Adult",
    "YOUTH": "(6-18) Youth"
  },
  "back": "Back",
  "cancel": "Cancel",
  "childCaregiverStatus": {
    "CAREGIVER": "Yes",
    "NOT_CAREGIVER": "No"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Satisfactory immigration status (green card, etc.)",
    "NOT_ANSWERED": "Prefer not to answer",
    "US_CITIZEN": "U.S. Citizen",
    "US_NATIONAL": "U.S. National"
  },
  "clear": "Clear",
  "clearAddress": "Clear address",
  "clearFilters": "Clear Filters",
  "clinic": "Clinic",
  "close": "Close",
  "continue": "Continue",
  "dateOfBirth": "Date of birth",
  "datePicker": {
    "placeholder": "Select a date",
    "required": "Please choose a date."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} day",
    "daysWithCount_other": "{{count}} days",
    "monthsWithCount_one": "{{count}} month",
    "monthsWithCount_other": "{{count}} months",
    "yearsWithCount_one": "{{count}} year",
    "yearsWithCount_other": "{{count}} years"
  },
  "day": "Day",
  "delete": "Delete",
  "discardFormChangesDialog": {
    "cancelButton": "Back to editing",
    "confirmButton": "Leave anyway",
    "creating": "creating",
    "description": "There are unsaved changes to the {{entity}} you are {{action}}. If you leave this page you will lose your progress.",
    "entity": "entity",
    "title": "Are you sure you want to leave?",
    "updating": "editing"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Proof of Immigration",
    "PROOF_OF_EXEMPTION": "Proof of Exemption",
    "PROOF_OF_EXPENSE": "Proof of Expense",
    "PROOF_OF_IDENTITY": "Proof of Identity",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Proof of Income and Employment",
    "PROOF_OF_INSURANCE": "Proof of Employer Sponsored Insurance or Other Insurance",
    "PROOF_OF_RESIDENCE": "Proof of Residence",
    "PROOF_OF_WORK": "Proof of Work",
    "SOCIAL_SECURITY_NUMBER": "Social Security Number"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Alimony Paid",
    "AUTHORIZED_EMPLOYMENT_ID": "Authorized Employment ID",
    "BANK_STATEMENTS": "Bank statements",
    "BIRTH_CERTIFICATE": "Birth Certificate",
    "CHILDCARE": "Childcare",
    "CHILDS_BIRTH_CERTIFICATE": "Child's Birth Certificate",
    "CHILDS_PASSPORT": "Child's Passport",
    "COURT_ORDERED_STATEMENTS": "Court ordered statements",
    "DOCTORS_NOTE": "Doctor's Note",
    "DRIVERS_LICENSE": "Driver's License",
    "EXPENSE_OTHER": "Other",
    "FOSTER_CARE_VERIFICATION_LETTER": "Foster Care Verification Letter",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Guardianship or Custody Papers",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Immigration Documents and Approvals",
    "INSURANCE_CARD": "Insurance Card",
    "INSURANCE_CARRIER_INFO": "Insurance Carrier - name and address",
    "INSURANCE_POLICY_NUMBER": "Policy Number",
    "IRA_CONTRIBUTIONS": "IRA Contributions",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Letter of statement from employer",
    "MEDICAL_EXPENSE": "Medical Expense",
    "MEDICARE_CARD": "Medicare Card",
    "MORTGAGE_STATEMENT": "Mortgage statement",
    "MOVING_EXPENSES": "Moving Expenses",
    "PASSPORT": "Passport",
    "PAY_STUBS": "Pay stubs (last 30 days)",
    "PENSION_STATEMENTS": "Pension statements",
    "PROPERTY_TAX_BILL": "Property Tax Bill",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Release or Discharge Paperwork",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Rent Receipt or Lease Agreement",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "School Enrollment Verification or Transcript",
    "SIGNED_LETTER": "Signed Letter",
    "SIGNED_TIMESHEETS": "Signed Timesheets",
    "SNAP_TANF_VERIFICATION_LETTER": "SNAP/TANF Verification Letter",
    "SOCIAL_SECURITY_CARD": "Social Security Card",
    "SSA_STATEMENTS": "SSA statements",
    "SSDI_STATEMENTS": "SSDI statements",
    "STATE_ID": "State ID",
    "STUDENT_LOANS": "Student Loans",
    "TAX_RETURN": "Tax Return (most recent)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Training or Apprenticeship Enrollment Certificate",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Treatment Program Enrollment Letter",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tribal Enrollment Card or Letter",
    "TUITION_FEES": "Tuition Fees",
    "UNEMPLOYMENT_STATEMENTS": "Unemployment statements",
    "USCIS_ID": "USCIS ID (non-citizen)",
    "UTILITY_BILL": "Utility Bill",
    "VA_DISABILITY_RATING_LETTER": "VA Disability Rating Letter",
    "W2_FORMS": "W-2 Forms",
    "descriptions": {
      "ALIMONY_PAID": "Divorce or separation agreement",
      "AUTHORIZED_EMPLOYMENT_ID": "Work authorization document from USCIS",
      "BANK_STATEMENTS": "Checking or savings statements from the last 30 days",
      "BIRTH_CERTIFICATE": "U.S. birth certificate with your name and date of birth.",
      "CHILDCARE": "Bank statement or receipt or letter from your childcare provider",
      "CHILDS_BIRTH_CERTIFICATE": "Birth certificate with your child's name and date of birth",
      "CHILDS_PASSPORT": "U.S. passport with your child's name and date of birth",
      "COURT_ORDERED_STATEMENTS": "Court order for child support, alimony, or workers' compensation",
      "DOCTORS_NOTE": "Letter from a doctor describing the medical condition, disability, or pregnancy this exemption is based on",
      "DRIVERS_LICENSE": "Current license with your name, date of birth, and address",
      "EXEMPTION_SSA_STATEMENTS": "Letter showing the Social Security benefit of the person you care for",
      "EXEMPTION_SSDI_STATEMENTS": "Letter showing the disability benefit of the person you care for",
      "EXPENSE_OTHER": "Court order or written agreement showing the payment amount",
      "FOSTER_CARE_VERIFICATION_LETTER": "Letter from your state foster care agency confirming your status and age",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Court order or custody papers showing you're the child's legal caregiver",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Work permit, visa, or other USCIS document showing your status",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Birth certificate with your name and date of birth.",
      "IMMIGRATION_PASSPORT": "Passport with your name and date of birth.",
      "INSURANCE_CARD": "Front and back of card with carrier name and policy number",
      "INSURANCE_CARRIER_INFO": "Document with insurance company name and address",
      "INSURANCE_POLICY_NUMBER": "Document showing your insurance policy or member ID number",
      "IRA_CONTRIBUTIONS": "Statement from your bank or IRA provider",
      "I_20": "Paper form from your school that shows you can study in the U.S.",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Letter confirming your job and pay",
      "MEDICAL_EXPENSE": "Bank statement or bill or receipt from your doctor, hospital, or pharmacy",
      "MEDICARE_CARD": "Medicare card showing you're enrolled in Medicare Part A and/or B",
      "MORTGAGE_STATEMENT": "Mortgage statement within the last 60 days with your address",
      "MOVING_EXPENSES": "Moving receipts and a letter from your employer",
      "PASSPORT": "U.S. passport with your name and date of birth.",
      "PAY_STUBS": "Pay stubs from the last 30 days showing gross pay and employer",
      "PENSION_STATEMENTS": "Statement showing your monthly pension amount",
      "PROPERTY_TAX_BILL": "Property tax bill with your address",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Paperwork showing your release date from jail or prison",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Rent receipt or lease showing your current address",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Letter or transcript showing you're enrolled at least half-time",
      "SIGNED_LETTER": "Letter confirming training, school, apprenticeship, or community service",
      "SIGNED_TIMESHEETS": "Timesheets signed by your employer or supervisor showing hours worked",
      "SNAP_TANF_VERIFICATION_LETTER": "Letter from your SNAP or TANF office confirming you're meeting their work requirements",
      "SOCIAL_SECURITY_CARD": "Card with your name and 9-digit Social Security number",
      "SSA_STATEMENTS": "Letter showing your monthly Social Security benefit",
      "SSDI_STATEMENTS": "Letter showing your monthly disability benefit",
      "STATE_ID": "Current state ID card with your name, date of birth, and address",
      "STUDENT_LOANS": "Statement from your bank or loan servicer",
      "TAX_RETURN": "Last year's complete tax return",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Certificate or letter showing you're enrolled in a training or apprenticeship program",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Letter confirming you're enrolled in a drug or alcohol treatment program",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tribal ID card or letter confirming your membership",
      "TUITION_FEES": "Receipt or bill from your school",
      "UNEMPLOYMENT_STATEMENTS": "Letter showing your weekly or monthly unemployment benefits",
      "USCIS_ID": "Green card, work permit, or citizenship certificate",
      "UTILITY_BILL": "Bill from the last 60 days for electric, gas, water, or phone with your address",
      "VA_DISABILITY_RATING_LETTER": "VA letter showing your 100% disability rating",
      "W2_FORMS": "Most recent W-2 showing your employer and wages"
    }
  },
  "documents": {
    "choosePhoto": "Choose Photo",
    "takePhoto": "Take Photo"
  },
  "done": "Done",
  "edit": "Edit",
  "email": "Email",
  "error": "Error",
  "errorFallback": {
    "description": "We ran into a problem loading this page.",
    "resetCta": "Try again",
    "title": "Something went wrong."
  },
  "errors": {
    "appleSsoNotSupported": "Apple sign in isn't available. Please try a different sign-in option.",
    "emptyHomeAddress": "Please enter and select a home address, or check \"No Home Address\".",
    "emptyMailingAddress": "Please enter and select a mailing address, or check \"No Mailing Address\".",
    "googleSsoNotSupported": "Google sign in isn't available. Please try a different sign-in option.",
    "invalidEmail": "Please enter a valid email address (for example, name@example.com).",
    "selectValidOption": "Please select a valid option.",
    "unableToCreateApplications": "We couldn't submit your applications. Please check your connection and try again.",
    "unauthenticated": "Please sign in to continue.",
    "unauthorized": "You don't have access to sign in. If you think this is a mistake, please contact us at support@pointcare.com.",
    "unknown": "Something went wrong. Please try again."
  },
  "exit": "Exit",
  "female": "Female",
  "filesWithCount_one": "{{count}} file",
  "filesWithCount_other": "{{count}} files",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Health insurance through a job (employer-sponsored)",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Other",
    "PRIVATE": "Private insurance or ACA Marketplace",
    "TRICARE": "TRICARE (military health coverage)",
    "VA": "VA Health Care Program"
  },
  "home": "Home",
  "householdMember": "Household Member",
  "listConnector": " and ",
  "listSeparator": ", ",
  "loading": "Loading...",
  "login": {
    "checkYourEmail": "Check your email {{email}} for a sign-in link.",
    "placeholder": "name@example.com",
    "sendEmail": "Send email"
  },
  "longDateFormat": "MMMM D, YYYY",
  "male": "Male",
  "maritalStatus": {
    "COMMON_LAW": "Common Law Marriage",
    "DIVORCED": "Divorced",
    "MARRIED": "Married",
    "NEVER_MARRIED": "Never Married",
    "REGISTERED_DOMESTIC_PARTNER": "Registered Domestic Partner",
    "SEPARATED": "Separated",
    "WIDOWED": "Widowed"
  },
  "marketplace": "ACA Marketplace",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Part C)",
    "NOT_SURE": "Not sure",
    "ORIGINAL": "Part A & B (Original)"
  },
  "member_one": "{{count}} member",
  "member_other": "{{count}} members",
  "month": "Month",
  "next": "Next",
  "no": "No",
  "noResults": "No results found",
  "noneOfTheAbove": "None of the above",
  "ok": "OK",
  "open": "Open",
  "or": "or",
  "pagination": {
    "goToFirstPage": "Go to first page",
    "goToLastPage": "Go to last page",
    "goToNextPage": "Go to next page",
    "goToPreviousPage": "Go to previous page",
    "morePages": "More pages",
    "pagination": "Pagination",
    "rowsPerPage": "Rows per page",
    "rowsResults": "{{from}} to {{to}} of {{total}} results",
    "showingPrefix": "Showing "
  },
  "payFrequency": {
    "ANNUALLY": "Annually",
    "BI_WEEKLY": "Bi-weekly",
    "MONTHLY": "Monthly",
    "WEEKLY": "Weekly"
  },
  "pdfViewer": {
    "loading": "Loading document..."
  },
  "program_one": "{{count}} program",
  "program_other": "{{count}} programs",
  "progressIndicator": "Progress: {{progress}} of {{total}} complete",
  "relationships": {
    "CHILD": "Child",
    "FOSTER_CHILD": "Foster Child",
    "GRANDCHILD": "Grandchild",
    "GRANDPARENT": "Grandparent",
    "OTHER": "Other",
    "PARENT": "Parent",
    "PARTNER": "Partner",
    "SIBLING": "Sibling",
    "SPOUSE": "Spouse",
    "STEPCHILD": "Stepchild"
  },
  "required": "This field is required.",
  "returnToDashboard": "Return to Dashboard",
  "save": "Save",
  "saveChanges": "Save changes",
  "share": "Share",
  "sidebar": {
    "title": "Sidebar",
    "toggle": "Toggle sidebar"
  },
  "signOut": "Sign out",
  "skip": "Skip",
  "stepIndicator": "Step {{currentStep}} of {{totalSteps}}",
  "submit": "Submit",
  "tabs": {
    "home": "Home"
  },
  "taxFilingStatus": {
    "HEAD": "Head of Household",
    "JOINTLY": "Married filing jointly",
    "NON_FILER": "Not filing",
    "SEPARATELY": "Married filing separately",
    "SINGLE": "Single",
    "WIDOWER": "Qualifying Widow(er) with Dependent Child"
  },
  "theme": "Theme",
  "time": {
    "am": "AM",
    "pm": "PM"
  },
  "undo": "Undo",
  "unknown": "Unknown",
  "uploadButton": {
    "title": "Upload a File or Take a Photo"
  },
  "validation": {
    "atLeastOneOption": "Please choose at least one option.",
    "genericError": "That didn't work. Please try again.",
    "invalidCode": "That code didn't match. Please check it and try again, or request a new code.",
    "invalidEmail": "Please enter a valid email address (for example, name@example.com).",
    "invalidNumber": "Please enter a valid number.",
    "invalidPassword": "That password doesn't look right. Please try again.",
    "invalidPhone": "Please enter a valid 10-digit phone number.",
    "invalidSsn": "Your Social Security Number should only contain digits (no dashes or spaces).",
    "invalidSsnFormat": "That doesn't look like a valid Social Security Number. Please check it and try again.",
    "invalidSsnLength": "Please enter your 9-digit Social Security Number.",
    "numberMustBeNonNegative": "Please enter a number that's zero or higher.",
    "passwordMismatch": "Passwords don't match.",
    "requiredField": "Please fill out this field.",
    "requiredFields": "Please fill out all of the required fields.",
    "requiredNonNegative": "Please enter a number that's zero or higher.",
    "requiredPassword": "Please enter your password.",
    "unknown": "Something went wrong. Please try again."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Enter your email to complete sign-in",
    "verify": "Verify",
    "verifyError": "We couldn't verify your sign-in link. It may have expired. Please request a new link."
  },
  "whoApplies": "Who does this apply to?",
  "whoIsApplying": "Who is applying?",
  "year": "Year",
  "yes": "Yes",
  "zoom": "Zoom",
  "zoomIn": "Zoom In",
  "zoomOut": "Zoom Out",
  "zoomReset": "Reset Zoom"
}
